import { baseApi } from '@/store/api/baseApi';
import type {
  CmsPage,
  CmsPagesResponse,
  CreateCmsPagePayload,
  UpdateCmsPagePayload,
} from '@/types/cms';

export const cmsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCmsPages: builder.query<CmsPagesResponse, void>({
      query: () => '/cms/pages',
      providesTags: (result) =>
        result?.results?.length
          ? [
              { type: 'Cms' as const, id: 'LIST' },
              ...result.results.map((page) => ({ type: 'Cms' as const, id: page.slug })),
            ]
          : [{ type: 'Cms', id: 'LIST' }],
    }),
    getCmsPage: builder.query<CmsPage, string>({
      query: (slug) => `/cms/pages/${encodeURIComponent(slug)}`,
      providesTags: (_result, _error, slug) => [{ type: 'Cms', id: slug }],
    }),
    createCmsPage: builder.mutation<CmsPage, CreateCmsPagePayload>({
      query: (body) => ({
        url: '/cms/pages',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Cms', id: 'LIST' }],
    }),
    updateCmsPage: builder.mutation<CmsPage, { slug: string; body: UpdateCmsPagePayload }>({
      query: ({ slug, body }) => ({
        url: `/cms/pages/update/${encodeURIComponent(slug)}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { slug }) => [
        { type: 'Cms', id: slug },
        { type: 'Cms', id: 'LIST' },
      ],
    }),
    deleteCmsPage: builder.mutation<{ message?: string }, string>({
      query: (slug) => ({
        url: `/cms/pages/${encodeURIComponent(slug)}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, slug) => [
        { type: 'Cms', id: slug },
        { type: 'Cms', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCmsPagesQuery,
  useGetCmsPageQuery,
  useCreateCmsPageMutation,
  useUpdateCmsPageMutation,
  useDeleteCmsPageMutation,
} = cmsApi;
